import { defineStyleConfig } from "@chakra-ui/react";

export const Textarea = defineStyleConfig({
  defaultProps: {
    variant: "filled",
  },
});
